import { useCallback, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { Tooltip } from "@mui/material"

import moment from "moment-timezone"

import { LayoutTemplate } from "lucide-react";

import '../projects.css';

import { Model } from "../../../models/model";
import { ModeGantt } from "../../tasks/ModeGantt"
import { DialogFormTask } from "../../tasks/DialogFormTask"
import { DialogTemplates } from "./templates/DialogTemplates"
import { TasksModeList } from "../../tasks/new/TasksModeList"

moment().tz("America/Lima").format()

export const ProjectsTaskNew2 = ({ id_ppto }) => {

    const { detail: detailPpto } = useSelector(state => state.ppto)

    const [hitosList, setHitosList] = useState([])
    const [blocksList, setBlocksList] = useState([])
    const [initialStateTask, setInitialStateTask] = useState([])

    const [tasksList2, setTasksList2] = useState([])

    const [openDialogFormTask, setOpenDialogFormTask] = useState(false)
    const [openTemplates, setOpenTemplates] = useState(false)
    const [reload_, setReload_] = useState(false)

    const savingStatus = false

    const [filters, setFilters] = useState({
        id_ppto: id_ppto,
        view: 'list',
        id_responsable: 0,
        estado: ''
    })

    const handleInitGetTasks = useCallback(async (filters) => {
        const params = (new URLSearchParams(filters)).toString()
        if (filters.view === 'gantt') {
            const resultsTasks = await Model.getAll({ url: `tasks/proyectos/all/tasks2/?${params}` })
            setBlocksList(resultsTasks[0]?.blocks || [])
            setHitosList(resultsTasks[0]?.tasks || [])
        } else {
            const resultsTasksList = await Model.getAll({ url: `tasks/?${params}` })
            setTasksList2(resultsTasksList)
        }

    }, [])

    const handleFilters = async ({ target }) => {
        const newData = {
            ...filters,
            [target.name]: target.value
        }

        setFilters(newData)
        await handleInitGetTasks(newData)
    }

    const handleEditTask = (currentTask) => {
        setInitialStateTask(currentTask)
        setOpenDialogFormTask(true)
    }

    const handleAddTaskFromTemplates = async (tasksListInput) => {
        await Model.save({
            url: `tasks/proyectos/loads-from-templates/${id_ppto}`,
            dataForm: {
                budget_id: id_ppto,
                tasks: tasksListInput
            }
        })

        setOpenTemplates(false)
        setReload_(true)
    }

    const handleTemplate = () => {
        setOpenTemplates(true)
    }

    useEffect(() => {
        handleInitGetTasks(filters)
    }, [filters, handleInitGetTasks])

    return (
        <div className="row">
            <div className="col p-project-detail-container" style={{ position: 'relative' }}>
                <div className="row pb-4">

                    {savingStatus ?

                        <div className="d-flex flex-column justify-content-center align-items-start ms-3">
                            <div class="spinner-border p-color-primary ms-2" role="status">
                                <span class="visually-hidden" style={{ color: 'red' }}>Loading...</span>
                            </div>
                            <div>Guardando...</div>
                        </div>

                        :

                        <div className="col d-flex justify-content-between align-items-start">

                            <div className="text-start">
                                <Tooltip title="Ver plantillas" placement="right">
                                    <button
                                        className='btn p-btn-secondary d-flex align-items-center'
                                        onClick={handleTemplate}
                                    >
                                        <LayoutTemplate className="w-4 h-4" />
                                        <label className="ms-1">Plantillas</label>
                                    </button>
                                </Tooltip>
                            </div>

                            <div className="views d-flex me-4">
                                <Link to="" onClick={() => handleFilters({ target: { name: 'view', value: 'list' } })} className={`p-views-links ${filters.view === 'list' ? 'p-links-line' : ''}`}>
                                    <span className="d-flex flex-column justify-content-center align-items-center">
                                        <i className="bi bi-list-check"></i>
                                        <span className="text">Lista</span>
                                    </span>
                                </Link>
                                <Link to="" onClick={() => handleFilters({ target: { name: 'view', value: 'gantt' } })} className={`p-views-links ${filters.view === 'gantt' ? 'p-links-line' : ''}`}>
                                    <span className="d-flex flex-column justify-content-center align-items-center ms-3">
                                        <i className="bi bi-list-nested"></i>
                                        <span className="text">Gantt</span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                    }

                </div>

                {openTemplates &&
                    <DialogTemplates
                        open={openTemplates}
                        setOpen={setOpenTemplates}
                        detailBudget={detailPpto}
                        detailTasks={tasksList2}
                        handleAddTaskFromTemplates={handleAddTaskFromTemplates}
                    />
                }

                {openDialogFormTask &&
                    <DialogFormTask
                        open={openDialogFormTask}
                        setOpen={setOpenDialogFormTask}
                        initialState={initialStateTask}
                        refreshObj={
                            {
                                fn_: handleInitGetTasks,
                                filters_: filters
                            }
                        }
                    />
                }

                {filters.view === 'list' ?
                    <TasksModeList
                        origen={{
                            from: 'project',
                            id: id_ppto,
                            reloadList: reload_,
                            ppto: detailPpto
                        }}
                    />
                    :
                    <ModeGantt
                        hitosList={hitosList}
                        blocksList={blocksList}
                        setOpenDialogFormTask={setOpenDialogFormTask}
                        handleEditTask={handleEditTask}
                    />
                }

                {/* <DragListExample /> */}

            </div>
        </div >
    )

}